/**
 * Builds the trigger-update payload when a PIN code is selected for an isUserLockOperation capability (any value type
 * of the method). Only capabilityDynamicFields changes — the method and selectedCapability are handled elsewhere.
 * The user_codes item id is resolved by the caller (memoized) and passed in.
 * @param {string} userCodesItemId - id of the user_codes item (resolved once by the caller)
 * @param {string} selectedAction - "state" field value
 * @param {string} pinKey - selected user_codes key ("user" field value)
 * @returns {Object} onDataUpdate payload
 */
export const buildPinCodeTriggerData = (userCodesItemId, selectedAction, pinKey) => {
    return {
        capabilityDynamicFields: {
            stateFieldValue: selectedAction,
            userCodesItemId,
            userFieldValue: pinKey,
        },
    };
};
